// extracted by mini-css-extract-plugin
export var aiStarSpin = "_qz-1";
export var spinner = "_qz-0";